interface SearchConditionSetting {
    itemCode: string
    itemName: string
    placeholder: string
    matchCheckboxFlag: boolean
    dialogFlag: boolean
    valueAssociatedWithCodeFlag: boolean,
    matchPattern: string[]
}

interface SearchItemState {
    itemCode: string;
    operator: 'AND' | 'OR';
    inputValue: string;
    inputLabel?: string;
    matchFlag?: boolean;
}

const conditionItemList: { [key: string]: SearchConditionSetting } = {
    kigyoCode: {
        itemCode: 'kigyoCode',
        itemName: '企業コード',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['prefix'],
    },
    jojo: {
        itemCode: 'jojo',
        itemName: '上場',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['equals'],
    },
    shogoKana: {
        itemCode: 'shogoKana',
        itemName: '商号(カナ)',
        placeholder: '',
        matchCheckboxFlag: true,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['equals', 'prefix'],
    },
    shogoKanji: {
        itemCode: 'shogoKanji',
        itemName: '商号(漢字)',
        placeholder: '',
        matchCheckboxFlag: true,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['equals', 'prefix'],
    },
    daihyoshaKana: {
        itemCode: 'daihyoshaKana',
        itemName: '代表者カナ',
        placeholder: '',
        matchCheckboxFlag: true,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['equals', 'prefix'],
    },
    daihyoshaKanji: {
        itemCode: 'daihyoshaKanji',
        itemName: '代表者漢字',
        placeholder: '',
        matchCheckboxFlag: true,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['equals', 'prefix'],
    },
    yubinNo: {
        itemCode: 'yubinNo',
        itemName: '郵便番号',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['prefix'],
    },
    shozaichi: {
        itemCode: 'shozaichi',
        itemName: '所在地',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['prefix'],
    },
    denwaNo: {
        itemCode: 'denwaNo',
        itemName: '電話番号',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['prefix'],
    },
    setsuritsu: {
        itemCode: 'setsuritsu',
        itemName: '設立年月',
        placeholder: 'YYYYMM',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    sogyo: {
        itemCode: 'sogyo',
        itemName: '創業年月',
        placeholder: 'YYYYMM',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    shihonkin: {
        itemCode: 'shihonkin',
        itemName: '資本金',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    jugyoinsu: {
        itemCode: 'jugyoinsu',
        itemName: '従業員数',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    gyoshu: {
        itemCode: 'gyoshu',
        itemName: '業種',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['prefix'],
    },
    yakuin: {
        itemCode: 'yakuin',
        itemName: '役員',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['contains'],
    },
    okabunushi: {
        itemCode: 'okabunushi',
        itemName: '大株主',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['contains'],
    },
    eigyoshumoku: {
        itemCode: 'eigyoshumoku',
        itemName: '営業種目',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['contains'],
    },
    shiiresaki: {
        itemCode: 'shiiresaki',
        itemName: '仕入先',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['contains'],
    },
    hanbaisaki: {
        itemCode: 'hanbaisaki',
        itemName: '販売先',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: false,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['contains'],
    },
    torihikiginko: {
        itemCode: 'torihikiginko',
        itemName: '取引銀行',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['prefix'],
    },
    kessangetsu: {
        itemCode: 'kessangetsu',
        itemName: '決算月',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    saishinuriage: {
        itemCode: 'saishinuriage',
        itemName: '最新売上',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    saishinrieki: {
        itemCode: 'saishinrieki',
        itemName: '最新利益',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    uriageshinchoritsu: {
        itemCode: 'uriageshinchoritsu',
        itemName: '売上伸長率',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    riekishinchoritsu: {
        itemCode: 'riekishinchoritsu',
        itemName: '利益伸長率',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    seinengappi: {
        itemCode: 'seinengappi',
        itemName: '生年月日',
        placeholder: 'YYYYMMDD',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['range', 'above', 'below'],
    },
    eto: {
        itemCode: 'eto',
        itemName: '干支',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['equals'],
    },
    shusshinko: {
        itemCode: 'shusshinko',
        itemName: '出身校',
        placeholder: '',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: false,
        matchPattern: ['equals'],
    },
    shusshinchi: {
        itemCode: 'shusshinchi',
        itemName: '出身地',
        placeholder: 'コード値',
        matchCheckboxFlag: false,
        dialogFlag: true,
        valueAssociatedWithCodeFlag: true,
        matchPattern: ['equals'],
    }
}

const initialSearchItemsState: { [key: string]: SearchItemState } = {
    kigyoCode: {
        itemCode: 'kigyoCode',
        operator: 'AND',
        inputValue: '',
    },
    jojo: {
        itemCode: 'jojo',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    shogoKana: {
        itemCode: 'shogoKana',
        operator: 'AND',
        inputValue: '',
        matchFlag: false,
    },
    shogoKanji: {
        itemCode: 'shogoKanji',
        operator: 'AND',
        inputValue: '',
        matchFlag: false,
    },
    daihyoshaKana: {
        itemCode: 'daihyoshaKana',
        operator: 'AND',
        inputValue: '',
        matchFlag: false,
    },
    daihyoshaKanji: {
        itemCode: 'daihyoshaKanji',
        operator: 'AND',
        inputValue: '',
        matchFlag: false,
    },
    yubinNo: {
        itemCode: 'yubinNo',
        operator: 'AND',
        inputValue: '',
    },
    shozaichi: {
        itemCode: 'shozaichi',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    denwaNo: {
        itemCode: 'denwaNo',
        operator: 'AND',
        inputValue: '',
    },
    setsuritsu: {
        itemCode: 'setsuritsu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    sogyo: {
        itemCode: 'sogyo',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    shihonkin: {
        itemCode: 'shihonkin',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    jugyoinsu: {
        itemCode: 'jugyoinsu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    gyoshu: {
        itemCode: 'gyoshu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    yakuin: {
        itemCode: 'yakuin',
        operator: 'AND',
        inputValue: '',
    },
    okabunushi: {
        itemCode: 'okabunushi',
        operator: 'AND',
        inputValue: '',
    },
    eigyoshumoku: {
        itemCode: 'eigyoshumoku',
        operator: 'AND',
        inputValue: '',
    },
    shiiresaki: {
        itemCode: 'shiiresaki',
        operator: 'AND',
        inputValue: '',
    },
    hanbaisaki: {
        itemCode: 'hanbaisaki',
        operator: 'AND',
        inputValue: '',
    },
    torihikiginko: {
        itemCode: 'torihikiginko',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    kessangetsu: {
        itemCode: 'kessangetsu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    saishinuriage: {
        itemCode: 'saishinuriage',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    saishinrieki: {
        itemCode: 'saishinrieki',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    uriageshinchoritsu: {
        itemCode: 'uriageshinchoritsu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    riekishinchoritsu: {
        itemCode: 'riekishinchoritsu',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    seinengappi: {
        itemCode: 'seinengappi',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    eto: {
        itemCode: 'eto',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
    shusshinko: {
        itemCode: 'shusshinko',
        operator: 'AND',
        inputValue: '',
    },
    shusshinchi: {
        itemCode: 'shusshinchi',
        operator: 'AND',
        inputValue: '',
        inputLabel: '',
    },
}

const dialogItems: { [key: string]: string } = {
    jojo: 'onClickJojoDialog',
    shozaichi: 'onClickShozaichiDialog',
    setsuritsu: 'onClickSetsuritsuDialog',
    sogyo: 'onClickSogyoDialog',
    shihonkin: 'onClickShihonkinDialog',
    jugyoinsu: 'onClickJugyoinsuDialog',
    gyoshu: 'onClickGyoshuDialog',
    torihikiginko: 'onClickTorihikiginkoDialog',
    kessangetsu: 'onClickKessangetsuDialog',
    saishinuriage: 'onClickSaishinuriageDialog',
    saishinrieki: 'onClickSaishinriekiDialog',
    uriageshinchoritsu: 'onClickUriageshinchoritsuDialog',
    riekishinchoritsu: 'onClickRiekishinchoritsuDialog',
    seinengappi: 'onClickSeinengappiDialog',
    eto: 'onClickEtoDialog',
    shusshinko: 'onClickShusshinkoDialog',
    shusshinchi: 'onClickShusshinchiDialog',
}

const rangeDialogItems = ['setsuritsu', 'sogyo', 'shihonkin', 'jugyoinsu', 'kessangetsu', 'saishinuriage', 'saishinrieki', 'uriageshinchoritsu', 'riekishinchoritsu', 'seinengappi']

export { conditionItemList, initialSearchItemsState, dialogItems, rangeDialogItems };
